import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "@shopify/app-bridge-react";
import LayoutRoot from "./layouts/LayoutRoot";
import PageLogin from "./pages/PageLogin";
import PageHome from "./pages/PageHome";
import PagePackageSizes from "./pages/PagePackageSizes";
import PagePackageSize from "./pages/PagePackageSize";
import PageRates from "./pages/PageRates";
import PageRate from "./pages/PageRate";
import PageWindows from "./pages/PageWindows";
import PageSettings from "./pages/PageSettings";
import PageSettingsDelivery from "./pages/PageSettingsDelivery";
import PageSettingsThemes from "./pages/PageSettingsThemes";
import PageSettingsWidget from "./pages/PageSettingsWidget";
import PageSettingsWidgetDelivery from "./pages/PageSettingsWidgetDelivery";
import PageSettingsWidgetPickup from "./pages/PageSettingsWidgetPickup";
import PageWindowsGroup from "./pages/PageWindowsGroup";
import "./css/shopify.min.css"

export default function App() {

    const host = new URLSearchParams(document.location.search).get("host");

    var isTest = document.location.host === "shoptest.urgent.co.nz" || document.location.host.includes(".staging.deliverdifferent.com");

    if (isTest)
        console.log("isTest:", process.env.REACT_APP_TEST_SHOPIFY_API_CLIENT_ID);

    const config = {
        // The client ID provided for your application in the Partner Dashboard.
        apiKey: isTest
            ? process.env.REACT_APP_TEST_SHOPIFY_API_CLIENT_ID
            : process.env.REACT_APP_SHOPIFY_API_CLIENT_ID,
        // The host of the specific shop that's embedding your app. This value is provided by Shopify as a URL query parameter that's appended to your application URL when your app is loaded inside the Shopify admin.
        host: host
    };

    useEffect(() => {
        if (!document.location.search.includes("session="))
            window.location.replace("/api/Auth/Install" + document.location.search);
    }, []);

    return (
        <Provider config={config}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LayoutRoot />}>
                        <Route index element={<PageHome />} />
                        <Route path="Login" element={<PageLogin />} />
                        <Route path="PackageSizes">
                            <Route index element={<PagePackageSizes />} />
                            <Route path=":id" element={<PagePackageSize />} />
                        </Route>
                        <Route path="Rates">
                            <Route index element={<PageRates />} />
                            <Route path=":id" element={<PageRate />} />
                        </Route>
                        <Route path="Windows">
                            <Route index element={<PageWindows />} />
                            <Route path=":id" element={<PageWindowsGroup />} />
                        </Route>
                        <Route path="Settings">
                            <Route index element={<PageSettings />} />
                            <Route path="Delivery" element={<PageSettingsDelivery />} />
                            <Route path="Themes" element={<PageSettingsThemes />} />
                            <Route path="Widget">
                                <Route index element={<PageSettingsWidget />} />
                                <Route path="Delivery" element={<PageSettingsWidgetDelivery />} />
                                <Route path="Pickup" element={<PageSettingsWidgetPickup />} />
                            </Route>
                        </Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </Provider>
    );
}
